import React, { useState } from "react"
import { Link } from "gatsby"

const Navigation = ({}) => {
  const [isExpanded, toggleExpansion] = useState(false)

  return (
    <nav className="w-full flex items-center justify-between flex-wrap p-6 lg:pl-0">
      <div className="flex items-center flex-shrink-0 text-white mr-6">
        <Link
          to="/"
          className="text-xl lg:text-2xl text-gray-800 outline-none pt-2 mt-1"
        >
          <h1>María Lourdes Echandi Gurdián</h1>
        </Link>
      </div>

      <div className="block lg:hidden">
        <button
          className="flex items-center px-3 py-2 border rounded text-gray-800 border-gray-400 hover:text-black hover:border-black"
          onClick={() => toggleExpansion(!isExpanded)}
        >
          <svg
            className="fill-current h-3 w-3"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div
        className={`${
          isExpanded ? `block` : `hidden`
        } w-full block flex-grow lg:flex lg:items-center lg:w-auto nav-links transition duration-400 ease-in-out transform`}
      >
        <div className="lg:flex-grow md:items-center lg:items-center ml-10 pt-3 tracking-tight">
          <div className="mt-4 lg:inline-block lg:mt-0 text-gray-800 text-lg hover:text-black mr-8">
            <Link to="/" activeClassName="underline">
              Inicio
            </Link>
          </div>

          <div className="mt-4 lg:inline-block lg:mt-0 text-gray-800 text-lg hover:text-black mr-8 ">
            <Link to="/publicaciones" activeClassName="underline">
              Publicaciones
            </Link>
          </div>

          <div className="mt-4 lg:inline-block lg:mt-0 text-gray-800 text-lg hover:text-black mr-8 ">
            <Link to="/contacto" activeClassName="underline">
              Contacto
            </Link>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navigation
